import React from 'react';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import About from './components/about';
import Founder from './components/Founder/Founder';
import Missions from './components/Missions/Missions';
import Actions from './components/Actions/Actions';
import { Episodes } from './components/Episodes/Episodes';
import Book from './components/Book/Book';
import { Team } from './components/Team/Team';
import { Gallery } from './components/Gallery/Gallery';
import { Partners } from './components/Partners/Partners';
import { Contact } from './components/Contact/Contact';
import { siteContent } from './data/content';

import './styles/globals.css';
import './App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <About />
        <Founder />
        <Missions />
        <Actions />
        <Episodes data={siteContent.gallery} />
        <Book />
        <Gallery data={siteContent.gallery} />
        <Team data={siteContent.teamData} />
        <Partners />
        <Contact data={siteContent.contactData} />
      </main>
    </div>
  );
}

export default App;

